import React from 'react';

const Sidebar = ({ currentCategory, onCategoryChange, currentTab, onTabChange, descentTabs, afterTabs }) => {
  const categories = [
    { id: 'home', label: 'Home', icon: '🏠' },
    { id: 'descent', label: 'Citizenship By Descent', icon: '🍁', tabs: descentTabs },
    { id: 'after', label: 'After Citizenship', icon: '🎉', tabs: afterTabs },
    { id: 'land_acknowledgement', label: 'Indigenous Homeland', icon: '🌎' },
    { id: 'about', label: 'Aboot Us and Contact', icon: 'ℹ️' },
  ];

  return (
    <div className="no-print" style={{
      width: '260px',
      backgroundColor: '#111827',
      color: 'white',
      height: '100vh',
      position: 'fixed',
      top: 0,
      left: 0,
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
    }}>
      <div style={{ padding: '24px', borderBottom: '1px solid #1f2937', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <img src="/canadian_flag.png" alt="Logo" width="32" />
          <span style={{ fontWeight: 'bold', fontSize: '1.25rem', letterSpacing: '-0.025em' }}>Lost & Found</span>
        </div>
        <span style={{ fontWeight: 'bold', fontSize: '1.25rem', letterSpacing: '-0.025em' }}>Canadians</span>
      </div>
      
      <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {categories.map(cat => (
          <React.Fragment key={cat.id}>
            <button
              onClick={() => onCategoryChange(cat.id)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                background: currentCategory === cat.id ? '#374151' : 'transparent',
                border: 'none',
                color: currentCategory === cat.id ? 'white' : '#9ca3af',
                padding: '12px 16px',
                textAlign: 'left',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: currentCategory === cat.id ? '600' : '500',
                fontSize: '0.95rem',
                transition: 'all 0.2s',
                width: '100%'
              }}
            >
              <span>{cat.icon}</span>
              {cat.label}
            </button>
            {currentCategory === cat.id && cat.tabs && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', marginBottom: '4px' }}>
                {cat.tabs.map(tab => (
                  <button
                    key={tab.id}
                    onClick={(e) => {
                      e.stopPropagation();
                      onTabChange(tab.id, cat.id);
                    }}
                    style={{
                      background: 'transparent',
                      border: 'none',
                      color: currentTab === tab.id ? '#60a5fa' : '#9ca3af',
                      padding: '8px 16px 8px 52px',
                      textAlign: 'left',
                      cursor: 'pointer',
                      fontSize: '0.85rem',
                      fontWeight: currentTab === tab.id ? '500' : '400',
                      transition: 'color 0.2s',
                      width: '100%'
                    }}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
      
      <div style={{ marginTop: 'auto', padding: '24px', borderTop: '1px solid #1f2937', color: '#6b7280', fontSize: '0.8rem' }}>
        &copy; {new Date().getFullYear()} Lost & Found Canadians. All rights reserved.
      </div>
    </div>
  );
};

export default Sidebar;